module.exports = __webpack_public_path__ + "img/photography-blog.b50cf346.gif";